module.exports = __webpack_public_path__ + "img/boss02_1780px.01d54966.jpg";